import {NgModule} from '@angular/core';
import {Routes, RouterModule, ExtraOptions} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import {WebsiteComponent} from "@pages/website/website.component";
import { AddCertificateFormComponent } from '@pages/agaram-selvi-module/add-certificate-form/add-certificate-form.component';
import { CertificateViewComponent } from '@pages/agaram-selvi-module/certificate-view/certificate-view.component';
import { AdminViewCertificateListComponent } from '@pages/agaram-selvi-module/admin-view-certificate-list/admin-view-certificate-list.component';

const routes: Routes = [
    {
        path: 'main',
        component: MainComponent,
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            {
                path: 'sub-menu-1',
                component: SubMenuComponent
            },
            {
                path: 'sub-menu-2',
                component: BlankComponent
            },
            {
                path: 'dash',
                component: DashboardComponent
            },
            {
                path: 'add-certificate',
                component: AddCertificateFormComponent
            },
            {
                path: 'admin-certificate-list-table',
                component : AdminViewCertificateListComponent
            },
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'certificate-view',
        component: CertificateViewComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'home',
        component: WebsiteComponent,
        canActivate: [NonAuthGuard]
    },
    {path: '**', redirectTo: '/login'}
];

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 80], // Optional
    useHash: true // ✅ Add this here
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
